import { PatrolCommunitySourceId } from '../models/patrol-community-source.model';

export const PATROL_ENABLED_SOURCES_PREF_KEY = 'patrolEnabledSources';

const VALID_SOURCE_IDS = new Set<PatrolCommunitySourceId>([
  'discord',
  'roblox',
  'minecraft',
]);

export function parsePatrolEnabledSources(
  raw: string | undefined,
): ReadonlySet<PatrolCommunitySourceId> {
  if (!raw) {
    return new Set();
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return new Set();
    }
    const ids = parsed.filter(
      (id): id is PatrolCommunitySourceId =>
        typeof id === 'string' && VALID_SOURCE_IDS.has(id as PatrolCommunitySourceId),
    );
    return new Set(ids);
  } catch {
    return new Set();
  }
}

export function serializePatrolEnabledSources(
  sources: ReadonlySet<PatrolCommunitySourceId>,
): string {
  return JSON.stringify([...sources]);
}
